import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/sharePopout.js';
// import s from 'components/bolt/header/sharePopout.sss';

export default class SharePopout extends BaseComp.default {

	componentDidMount() {
		if (typeof super.componentDidMount === 'function') {
			super.componentDidMount();
		}
		this.shareCopy = this.getShareCopy();
	}

	getShareCopy() {
		const { pageId, copy } = this.props;
		return copy[`$SOCIAL_COPY_${pageId}`] || copy.$SOCIAL_COPY;
	}

	getShareURL(type) {
		let url = super.getShareURL(type);
		if (url?.endsWith('/home/')) {
			const additions = {
				copy: 'ctc1',
				twitter: 'tw1',
				facebook: 'fb1',
				pinterest: 'pin1',
				tumblr: 'tmb1',
				email: 'em1',
				telegram: 'tele1',
			};
			const addition = additions[type];
			if (addition) {
				url = url.slice(0, -5) + addition;
			}
		}
		return url;
	}
}
